module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SitePage",
    staticStyle: {
      "background-color": "#f8f8f4",
      "position": "fixed",
      "min-height": "100%",
      "min-width": "100%",
      "padding": "0 0 0 0"
    },
    model: {
      value: (_vm.getVersionInfo),
      callback: function($$v) {
        _vm.getVersionInfo = $$v
      },
      expression: "getVersionInfo"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#0c2544",
      "position": "absolute",
      "height": "100%",
      "width": "260px"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "simple-text",
    staticStyle: {
      "font-size": "20px",
      "color": "#fff",
      "font-weight": "bold",
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "normal"
    }
  }, [_vm._v("\n          Version " + _vm._s(_vm.version) + " (" + _vm._s(_vm.date) + ")\n        ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('LocaleSwitcher')], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "-260px"
    }
  }, [_c('form', {
    staticStyle: {
      "max-width": "500px",
      "min-width": "100px",
      "margin": "0 auto"
    },
    attrs: {
      "name": "RegisterForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.tryRegister.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("Register")))]), _vm._v(" "), (_vm.registerResult != '') ? _c('div', {
    staticClass: "section"
  }, [_vm._v(_vm._s(_vm.registerResult))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section form-input-validate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerUserName),
      expression: "registerUserName"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": _vm.$t('placeholder.Username'),
      "required": "required"
    },
    domProps: {
      "value": (_vm.registerUserName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerUserName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section form-input-validate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerPassword),
      expression: "registerPassword"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$t('placeholder.Password'),
      "required": "required"
    },
    domProps: {
      "value": (_vm.registerPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section form-input-validate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerDisplayName),
      expression: "registerDisplayName"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "text",
      "name": "displayname",
      "placeholder": _vm.$t('placeholder.Display name (optional)')
    },
    domProps: {
      "value": (_vm.registerDisplayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerDisplayName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section form-input-validate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerEmail),
      expression: "registerEmail"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": _vm.$t('placeholder.Email (optional)')
    },
    domProps: {
      "value": (_vm.registerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "section btn __l __block",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("Register")))]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("register.Already registered?")) + "\n          "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("Login")) + "\n          ")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://ocds.co",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/optima-inverted-logo.png",
      "width": "160px",
      "vertical-align": "middle",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4e9fbde","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/RegisterPage.vue
// module id = 399
// module chunks = 1